// Introducing the method of registering components
import { withInstall } from '@/utils';
// Introducing Components
import loadingComp from './Loading.vue';
// Throw component
export const AmzLoading = withInstall(loadingComp, 'AmzLoading');
